interface DividerProps {
  color?: string;
}

export default function Divider({ color = '#e5e7eb' }: DividerProps) {
  return <hr className="my-4" style={{ borderColor: color }} />;
}
